import { TimesheetEntry } from "./types";
import { error, result, Either } from "../utils/fp/either";
import { omit } from "lodash/fp";

function exportData(entries: TimesheetEntry[], filename: string) {
  const json = JSON.stringify({ entries: entries.map(omit("id")) });

  const buffer = Buffer.from(json);
  var a = document.createElement("a"),
    url = URL.createObjectURL(new Blob([buffer]));
  a.href = url;
  a.download = `${filename}.timesheet.json`;
  document.body.appendChild(a);
  a.click();

  function handleFocus() {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  window.addEventListener("focus", handleFocus, { once: true });
}

function importData(file: File) {
  const reader = new FileReader();

  return new Promise<Either<string, TimesheetEntry[]>>(resolve => {
    reader.onload = b => {
      try {
        const { entries } = JSON.parse(b.target?.result?.toString()!);

        if (!Array.isArray(entries)) {
          return resolve(error("Ungültige Datei"));
        }

        resolve(
          result(
            entries.map((e: any) => ({
              ...e,
              start: new Date(e.start)
            }))
          )
        );
      } catch (err) {
        resolve(error("Ungültige Datei"));
      }
    };
    reader.readAsText(file as Blob, "utf8");
  });
}

const ShareAPI = {
  exportData,
  importData
};

export default ShareAPI;
